import { useRef, useEffect } from 'react';
import { useQuery } from 'react-query';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Messages } from 'primereact/messages';
import { Button } from 'primereact/button';
import { getAllPlaces } from '../../../services/acl';
import { TitleWrapper } from '../../Headings/common';
import { PageTitle } from '../../Headings';
import { useRefreshPlaceSeeds } from '../../../services/mutations';
import { getAxiosError } from '../../../utils/axiosError';

function PlaceList() {
  const { data, isFetching, error } = useQuery('placeList', getAllPlaces);
  const refreshSeeds = useRefreshPlaceSeeds();
  const messages = useRef<Messages>(null);

  const handleRefreshSeeds = () => {
    refreshSeeds.mutate(undefined, {
      onError: (err: any) => {
        messages.current?.show({ severity: 'error', summary: getAxiosError(err), sticky: true, closable: true });
      },
    });
  };

  useEffect(() => {
    if (error) {
      messages.current?.show({ severity: 'error', summary: 'An error has occurred while loading data!', sticky: true });
    }
  }, [error]);

  return (
    <div>
      <Messages ref={messages} />
      <TitleWrapper>
        <PageTitle>Place List</PageTitle>
        <div>
          <Button
            icon="pi pi-refresh"
            size="small"
            label="Refresh seeds"
            loading={refreshSeeds.isLoading}
            onClick={handleRefreshSeeds}
          />
        </div>
      </TitleWrapper>
      <DataTable loading={isFetching} value={data} rows={15} size="small" rowHover paginator>
        <Column header="Code" field="code" sortable />
        <Column header="Place Name" field="name" sortable />
      </DataTable>
    </div>
  );
}

export default PlaceList;
